'use client'

import { forwardRef } from 'react'

import { tw } from '@/lib/utils'

const ctaClasses =
  '!px-auto laptop:min-w-[205px] flex items-center justify-center gap-[0.4rem] text-center w-auto bg-lapis shadow-none rounded-[1.7rem] cursor-pointer hover:bg-navy disabled:bg-lapis disabled:opacity-40 disabled:cursor-not-allowed disabled:max-h-[48px] text-white'

export const Cta = forwardRef<HTMLButtonElement, React.ButtonHTMLAttributes<HTMLButtonElement>>(
  ({ className, children, ...props }, ref) => {
    return (
      <button ref={ref} className={tw(ctaClasses, className)} {...props}>
        {children}
      </button>
    )
  }
)

Cta.displayName = 'Cta'

export const CtaLink = forwardRef<HTMLAnchorElement, React.AnchorHTMLAttributes<HTMLAnchorElement>>(
  ({ className, children, ...props }, ref) => {
    return (
      <a ref={ref} className={tw(ctaClasses, className)} {...props}>
        {children}
      </a>
    )
  }
)

CtaLink.displayName = 'CtaLink'
